import { CatchAnimBase } from "./AnimBase";
import { GoalieCatchAnim } from "./Goalie";



/**
 * Nizky skok do strany s posunem na X
 */
export class Anim4 extends CatchAnimBase {
    /**
     * Cas od zacatku animace, kdy je mozne zahajit pohyb
     */
    private static readonly MOVE_START_TIME = 18 / 30;
    private static readonly MOVE_PEEK_TIME = 33 / 30;
    private static readonly MOVE_END_TIME = 40 / 30;

    private static readonly FLAG_START_MOVE = 2;
    private static readonly FLAG_MOVE = 4;

    /**
     * Vzdalenost posunu
     */
    private _moveDis: number;
    /**
     * Pocatecni pozice brankare na ose X
     */
    private _goalieStartX: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(ballPos: pc.Vec2, ballTime: number, data: GoalieCatchAnim): void {
        this._flags = 0;

        // Cas spusteni animace
        this._animStartTime = ballTime - data.animTimeOffset;

        // Horizontalni posun pres "side step" animaci
        let goaliePos = this._goalie.entity.getPosition();
        let hDis = ballPos.x - goaliePos.x;
        let hDir = hDis < 0 ? -1 : 1;
        let noMoveZoneX = goaliePos.x + data.noHMoveZone.originX * hDir;

        this._moveDis = 0;

        if (ballPos.x < noMoveZoneX - data.noHMoveZone.halfWidth || ballPos.x > noMoveZoneX + data.noHMoveZone.halfWidth) {
            // Horizontalni posun behem letu
            this._moveDis = ballPos.x - (noMoveZoneX + data.noHMoveZone.halfWidth * hDir);
            this._goalieStartX = goaliePos.x;
            this._flags |= Anim4.FLAG_START_MOVE;
        }

        // Jmeno animace
        this._animName = data.animName + (hDis > 0 ? "L" : "R");
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        super.update();

        if ((this._flags & CatchAnimBase.FLAG_ANIM_RUNNING) != 0 && (this._flags & (Anim4.FLAG_START_MOVE | Anim4.FLAG_MOVE)) != 0) {
            let entity = this._goalie.entity;
            let animTime = entity.animation.currentTime;

            if (animTime >= Anim4.MOVE_START_TIME && (this._flags & Anim4.FLAG_START_MOVE) != 0) {
                this._flags &= ~Anim4.FLAG_START_MOVE;
                this._flags |= Anim4.FLAG_MOVE;
            }

            if ((this._flags & Anim4.FLAG_MOVE) != 0) {
                let pos = entity.getPosition();

                if (animTime > Anim4.MOVE_END_TIME) {
                    this._flags &= ~Anim4.FLAG_MOVE;
                }
                else {
                    let progress = (animTime - Anim4.MOVE_START_TIME) / (Anim4.MOVE_PEEK_TIME - Anim4.MOVE_START_TIME);
                    pos.x = this._goalieStartX + this._moveDis * progress;
                }

                entity.setPosition(pos);
            }
        }
    }
}